/**
 * Users Resource Configuration
 */

export default {
  // Users resource config can be expanded later
};
